var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('radar-chart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }